export default __webpack_public_path__ + "956d575c1774e33a02857310f0ccc7fe.svg";